<template>
    <div 
        v-if="powerData && powerData.length > 0"
        class="graph-container"
    >
        <div
            :ref="`globalGraph-${uid}`"
            :id="`globalGraph-${uid}`"
            class="graph-container__global-graph"
        ></div>
    </div>
</template>

<script>
import Plotly from 'plotly.js-basic-dist';
import moment from 'moment';
export default {

    name: 'PowerData',

    components:{
    },

    props: {
        powerData:{
            type: Array,
            required: true
        },
        uid:{
            type: String,
            required: true
        },
        entity:{
            type: String,
            required: true
        },
        date:{
            type: String,
            required: false,
            default: null
        },
        startDate:{
            type: String,
            required: false,
            default: null
        },
        endDate:{
            type: String,
            required: false,
            default: null
        },

    },

    data () {
        return {
            globalAsset: null,
            dailyGraphsData: {},
            dailyGraphLength: 0,
        };
    },

    computed:{
        entityVerbose(){
            switch (this.entity) {
                case 'zone':
                    return 'de la zone';
                case 'machine':
                    return 'de la machine';
                case 'workshop':
                    return 'de l\'atelier';
                case 'motor':
                    return 'du moteur';
                default:
                    return 'du site';
            }
        }
    },

    mounted(){
        if(this.powerData && this.powerData.length > 0){
            this.makeGlobalPlotly();
        }
    },

    methods:{
        makeGlobalPlotly() {
            let x = this.powerData.map(elt => moment(elt.date)
            .tz("Europe/Paris")
            .format());
            let y = this.powerData.map(elt => elt.value);
            let datesInAxisX = x.map(dateString => moment(dateString));
            let dateMin = moment.min(datesInAxisX).format('DD/MM/YYYY');
            let dateMax = moment.max(datesInAxisX).format('DD/MM/YYYY');

            let traces = [{
                x: x,
                y: y,
                mode:'lines'
            }];

            let title = `Puissance active ${this.entityVerbose} sur la période du ${dateMin} au ${dateMax}`;
            if(this.date){
                title = `Puissance active ${this.entityVerbose} pour le ${moment(this.date).local().format('DD/MM/YYYY')}`;
            }
            // Use annotations because yaxis.title cannot be rotated
            let layout = {
                title: title,
                height: 600,
                width: 700,
                annotations: [{
                    xref: 'paper',
                    yref: 'paper',
                    x: 0,
                    xanchor: 'right',
                    y: 1,
                    text: '',
                    yanchor: 'bottom',
                    showarrow: false,
                }],
                yaxis: {
                    title: 'Puissance active (kW)'
                },
                xaxis: {
                    title: 'Date'
                }
            };
            Plotly.newPlot(`globalGraph-${this.uid}`, traces, layout);
            this.$refs[`globalGraph-${this.uid}`].on('plotly_relayout', () => {});
        },
    }
};
</script>

<style lang="scss">
.graph-container{
    width: 100%;
    &__global-graph{
        margin-bottom: 2rem;
        flex-grow: 1;
        .plot-container{
            display: flex;
            justify-content: center;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page/DataView/PowerGraph.vue